import { useInfiniteQuery } from 'react-query';
import { queryGet } from '@pocapan/shared/utils/queryClient';

const DEFAULT_PAGE = 5;

export default function useSalesTradingPhotoCardsQuery(photoCardId, perPage) {
  async function fetchSalesTradingPhotoCards({ pageParam = 1 }) {
    const queryParams = new URLSearchParams({
      per_page: perPage || DEFAULT_PAGE,
      page: pageParam
    });

    const url = `/api/v1/photo_cards/${photoCardId}/sales_trading_photo_cards?${queryParams.toString()}`;
    try {
      const salesTradingPhotoCards = await queryGet(url);
      return salesTradingPhotoCards;
    } catch (_error) {
      throw new Error('Error fetching paginated data.');
    }
  }

  const { data, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery(
    ['salesTradingPhotoCards', photoCardId],
    fetchSalesTradingPhotoCards,
    {
      enabled: !!photoCardId,
      getNextPageParam: (lastPage, _) => lastPage?.meta?.pagination?.nextPage
    }
  );

  return {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage
  };
}
